import cakeService from "@/services/cakephp";
import { cakeBaseURL } from '@/services/config.js'
import moment from 'moment';

const getAllClients = async ({ commit }, params) => {
  try {
    const { list } = await cakeService.getClientes();
    commit('LIST_ALL_CLIENTS', list);
  } catch (error) {

  }
}
const getTotalClients = async ({ commit }) => {
  try {
    const { count } = await cakeService.getTotalClients()
    commit('SET_TOTAL_CLIENTS', count);
  } catch (error) {

  }
}
const getPendenciesClients = async ({ commit }) => {
  try {
    const { pendents_by_client } = await cakeService.getPendenciesClients()
    const sum = pendents_by_client.reduce((previousValue, currentValue) => Number(previousValue) + Number(currentValue.v), 0)
    commit('SET_PENDENCIES_CLIENTS', sum);
  } catch (error) {

  }
}
const getServicesPendecies = async ({ commit }) => {
  return cakeService.getServicesPendecies()
}

const getAveragePaymentTime = async ({ commit }) => {
  
  try {
    var sum = 0
    var count = 0
    const { closed_bills } = await cakeService.getAveragePaymentTime()
    await closed_bills.map( bill => {
      var start = new Date(bill.s)
      var end = new Date(bill.e)
      var duration = Math.abs(end - start);
      if (duration) {
        count++
        sum += duration/(1000 * 3600 * 24)
      }
    })
    const average = sum / count
    commit('SET_AVERAGE_PAYMENT_TIME', average.toFixed());
  } catch (error) {

  }
}

const getBillsClient = async (context , { id }) => {
  try {
    const response = await cakeService.getCliente(id)
    return response

  } catch (error) {

  }
}

export default {
  getAllClients,
  getBillsClient,
  getTotalClients,
  getPendenciesClients,
  getAveragePaymentTime,
  getServicesPendecies
}
